// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2QlAz","title":"ClientInsurance_title__294XB","itemText":"ClientInsurance_itemText__RPhxQ"};